import React, { useEffect, useRef, useState } from 'react'
import Header from '../../component/Header';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';
import Testimonial from '../../component/Testimonial';
import { Link } from 'react-router-dom';

export default function Overview(props) {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    // Function to toggle play/pause
    const togglePlayPause = () => {
        if (videoRef.current.paused) {
            videoRef.current.play();
            setIsPlaying(true);
        } else {
            videoRef.current.pause();
            setIsPlaying(false);
        }
    };

    return (
        <>
            <Header />
            <section className='overview-banner top bottom p-l-r'>
                <div className='container-fluid p_r'>
                    <div className='row m_r'>
                        <div className='col-lg-7'>
                            <div className='left-section'>
                                <h1>Take a moment for yourself, slow down,<br /> and reflect.</h1>
                                <h6>Offering a safe, friendly space for personal growth, the app guides you through step-by-step soul detox!</h6>
                                <h6>Quiet the noise, focus on the present, and nurtures a sense of inner peace.</h6>
                                <div className='overview-second-section pt-4'>
                                    <div className='container-fluid p-0 m-0'>
                                        <div className='row m-0'>
                                            <div className='col-lg-6 p-0 mb-4'>
                                                <div className='overview-box-left-right'>
                                                    <div className='left-section same-card-two'>
                                                        <div className='same-card-content'>
                                                            <h3><span>For</span><br /> individuals</h3>
                                                        </div>
                                                        <div className='img-card-same'>
                                                            <img src={require('../../assets/images/individuals.jpg')} alt='individuals' />
                                                        </div>
                                                    </div>
                                                    <div className='over-content-part'>
                                                        <p>We would be your pocket sized wellness companion.</p>
                                                        <Link to='/services/individuals' className='common_btn'>Know More <i class="fa-solid fa-arrow-right"></i></Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 mb-4'>
                                                <div className='overview-box-left-right'>
                                                    <div className='right-section same-card-two'>
                                                        <div className='same-card-content'>
                                                            <h3><span>For</span><br /> Companies</h3>
                                                        </div>
                                                        <div className='img-card-same'>
                                                            <img src={require('../../assets/images/companies.jpg')} alt='companies' />
                                                        </div>
                                                    </div>
                                                    <div className='over-content-part'>
                                                        <p>Improving employee wellness, as experiences of life become the lessons of life.</p>
                                                        <Link to='/services/companies' className='common_btn'>Know More <i class="fa-solid fa-arrow-right"></i></Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-5 p_r'>
                            <div className='right-section'>
                                <div className='over-video-box'>
                                    <div className='over-video-box-2'>
                                        {/* <img src={require('../../assets/images/overview.gif')} /> */}
                                        {/* <button onClick={togglePlayPause} type='button' className='play_btn_box'>
                                            {
                                                isPlaying ? <i class="fa-solid fa-pause"></i> : <i class="fa-solid fa-play"></i>
                                            }
                                        </button> */}
                                        <video className=""
                                            ref={videoRef}
                                            autoPlay
                                            muted
                                            playsInline
                                            loop
                                            src="https://static.thebeyondlifestyle.com/grid_reel_1.mp4"></video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Testimonial />
        </>
    )
}
